<div class="dispute-container">
  <div class="search-filters">
    <div class="filters-container">
      <div class="filter-item filter-dropdown">
        <label for="userName" class="filter-label">
          {{ 'DISPUTE_PAGE.FILTER_LABELS.USER' | translate }}
        </label>
        <input
          type="text"
          pInputText
          placeholder="{{ 'DISPUTE_PAGE.PLACEHOLDERS.ENTER_USER_NAME' | translate }}"
          class="filter-field"
          id="userName"
          [(ngModel)]="filters.userName"
          (input)="applyFilters()"
        />
      </div>
      <div class="filter-item filter-dropdown">
        <label for="disputeTypes" class="filter-label">
          {{ 'DISPUTE_PAGE.FILTER_LABELS.ISSUE' | translate }}
        </label>
        <p-multiSelect
          [options]="disputeTypes"
          [(ngModel)]="filters.disputeTypes"
          id="disputeTypes"
          optionLabel="disputeType"
          optionValue="id"
          [showToggleAll]="false"
          placeholder="{{ 'DISPUTE_PAGE.PLACEHOLDERS.SELECT_DISPUTE_TYPE' | translate }}"
          (onChange)="applyFilters()"
        ></p-multiSelect>
      </div>
      <div class="filter-item filter-dropdown">
        <label for="disputeStatus" class="filter-label">
          {{ 'DISPUTE_PAGE.FILTER_LABELS.STATUS' | translate }}
        </label>
        <p-multiSelect
          [options]="disputeStatuses"
          [(ngModel)]="filters.disputeStatus"
          id="disputeStatus"
          optionLabel="status"
          optionValue="id"
          [showToggleAll]="false"
          placeholder="{{ 'DISPUTE_PAGE.PLACEHOLDERS.SELECT_DISPUTE_STATUS' | translate }}"
          (onChange)="applyFilters()"
        ></p-multiSelect>
      </div>
      <a class="reset-link text-primary" (click)="onResetFilters()">
        {{ 'DISPUTE_PAGE.BUTTONS.RESET' | translate }}
      </a>
    </div>

    <div class="export-container">
      <p-button
        label="{{ 'DISPUTE_PAGE.BUTTONS.EXPORT' | translate }}"
        icon="pi pi-download"
        class="p-button-primary export-button"
        (click)="exportData()"
      ></p-button>
    </div>
  </div>

  <p-table
    [value]="disputeItems.length !== 0 ? disputeItems : noDataRow"
    [paginator]="disputeItems.length !== 0 ? true : false"
    [rows]="rows"
    [first]="first"
    [totalRecords]="totalRecords"
    [lazy]="true"
    (onPage)="pageChange($event)"
    (onSort)="sortChange($event)"
    [rowsPerPageOptions]="tableParams.ROW_PER_PAGE"
    sortField="CreatedOn"
    [sortOrder]="-1"
  >
    <ng-template pTemplate="header" class="table-head">
      <tr>
        <th pSortableColumn="CreatedOn">
          {{ 'DISPUTE_PAGE.DISPUTES_TABLE.DATE' | translate
          }}<p-sortIcon field="CreatedOn"></p-sortIcon>
        </th>
        <th pSortableColumn="raisedByName">
          {{ 'DISPUTE_PAGE.DISPUTES_TABLE.RAISED_BY' | translate }}
          <p-sortIcon field="raisedByName"></p-sortIcon>
        </th>
        <th pSortableColumn="DisputeType">
          {{ 'DISPUTE_PAGE.DISPUTES_TABLE.DISPUTE_TYPE' | translate }}
          <p-sortIcon field="DisputeType"></p-sortIcon>
        </th>
        <th pSortableColumn="DisputeStatus">
          {{ 'DISPUTE_PAGE.DISPUTES_TABLE.STATUS' | translate }}
          <p-sortIcon field="DisputeStatus"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-dispute>
      <tr
        *ngIf="disputeItems?.length !== 0"
        (click)="goToCallDetailsPage(dispute.callId, dispute.id)"
      >
        <td>
          {{
            dispute?.modifiedOn ? (getConvertedDate(dispute.modifiedOn) | date: 'dd-MMM-YYYY') : ''
          }}
        </td>
        <td>{{ dispute.raisedByName }}</td>
        <td>{{ dispute.disputeType }}</td>
        <td>
          <span
            class="badge"
            [ngClass]="{
              'status-success': dispute.disputeStatus === statuses.RESOLVED,
              'status-danger': dispute.disputeStatus === statuses.OPEN,
              'status-warning': dispute.disputeStatus === statuses.UNDER_REVIEW,
              'status-dark': dispute.disputeStatus === statuses.CLOSED,
            }"
          >
            {{ dispute.disputeStatus }}
          </span>
        </td>
      </tr>
      <tr *ngIf="disputeItems?.length === 0">
        <td colspan="5" class="no-data-available">
          {{ 'COMMON.NO_AVAILABLE' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
